<template>
  <a @click="triggerAction">
    <MIcon v-if="useIcon" name="history" class="action-menu-icon" />
    <span class="ml-1 action-menu-text">
      {{ $tc('audit_trail') }}
    </span>
    <FlotoDrawer :open="showDrawer" @hide="showDrawer = false">
      <template v-slot:title>
        {{ $tc('audit_trail', 2) }}
      </template>
      <AuditContainer :module-name="moduleName" :resource-id="resourceId" />
    </FlotoDrawer>
  </a>
</template>

<script>
import AuditContainer from '@components/audit/audit-container'

export default {
  name: 'Audit',
  components: { AuditContainer },
  props: {
    useIcon: { type: Boolean, default: false },
    moduleName: { type: String, required: true },
    resourceId: { type: Number, required: true },
  },
  data() {
    return {
      showDrawer: false,
    }
  },
  methods: {
    triggerAction() {
      this.$emit('trigger')
      setTimeout(() => {
        this.showDrawer = true
      }, 400)
    },
  },
}
</script>
